import React from "react";
// import LocationOnIcon from "@material-ui/icons/LocationOn";
import ApartmentIcon from "@material-ui/icons/Apartment";
// import LocationCityIcon from "@material-ui/icons/LocationCity";
// import BusinessIcon from "@material-ui/icons/Business";
// import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";
import PersonPinIcon from "@material-ui/icons/PersonPin";
import GroupIcon from "@material-ui/icons/Group";
import { UIStyledTooltip } from "../ui/UIComponents";
import { NavLink } from "react-router-dom";
import { getFacilityLink, IPSFacility, IPSAgent, getAgentLink, AddressType } from "../../models/peer-support";
import { AgentMarkerData } from "../../models/peer-support/markers";
import { GeoLocation } from "../../laco-common/base/models/address";
import "./MapMarker.scss";

// dana can add a tooltip for phone no, address. Add click event with full address
export const MapMarker = ({ text, lat, lng, tooltip }) => (
	<UIStyledTooltip title={tooltip}>
		<span
			className="d-inline-flex flex-column align-items-center justify-content-center text-primary text-center"
			style={{ minWidth: "80px", textAlign: "center" }}
		>
			{/* <LocationOnIcon color="primary" /> */}
			<ApartmentIcon color="primary" />
			{/* <BusinessIcon color="primary" />
			<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
				<path d="M21 22h2v2h-22v-2h2v-22h18v22zm-10-3h-2v4h2v-4zm4 0h-2v4h2v-4zm4-17h-14v20h2v-5h10v5h2v-20zm-12 11h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8-3h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8-3h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-8-3h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z" />
			</svg> */}
			{text}
		</span>
	</UIStyledTooltip>
);

export const MapMarkerFacility = (props: { facility: IPSFacility } & GeoLocation) => (
	<NavLink to={getFacilityLink(props.facility)}>
		<UIStyledTooltip title={props.facility.address?.formatted_address}>
			<span
				className="d-inline-flex flex-column align-items-center justify-content-center text-primary text-center"
				style={{ minWidth: "80px", textAlign: "center" }}
			>
				<ApartmentIcon color="primary" />
				{props.facility.name}
			</span>
		</UIStyledTooltip>
	</NavLink>
);

export const MapMarkerAgent = (props: { agent: IPSAgent; addressType: AddressType } & GeoLocation) => {
	const tooltip: string =
		props.addressType === "Home"
			? props.agent.showHomeZipCodeOnly === "Yes"
				? props.agent.homeAddress.zip_code
				: props.agent.homeAddress.formatted_address
			: props.agent.showWorkZipCodeOnly === "Yes"
			? props.agent.workAddress.zip_code
			: props.agent.workAddress.formatted_address;
	return (
		<NavLink to={getAgentLink(props.agent)}>
			{/* title={props.facility.address?.formatted_address} */}
			<UIStyledTooltip title={tooltip}>
				<span
					className="d-inline-flex flex-column align-items-center justify-content-center text-primary text-center"
					style={{ minWidth: "80px", textAlign: "center" }}
				>
					<PersonPinIcon color="primary" />
					{props.agent.first_name} {props.agent.last_name}
				</span>
			</UIStyledTooltip>
		</NavLink>
	);
};

export const MapMarkerClusteredAgents = (props: { agents: AgentMarkerData[]; center: google.maps.LatLng }) => {
	if (!props.agents || !props.agents.length) return null;
	const tooltip: string = props.agents.map((a) => a.name).join(", ");
	const url: string =
		props.agents.length === 1 ? getAgentLink((props.agents[0] as any) as IPSAgent) : `/ps/peers/?q=${tooltip}`;
	// : `/ps/peers/?lat=${props.center.lat()}&lng=${props.center.lng()}`;
	return (
		<NavLink to={url}>
			<UIStyledTooltip title={tooltip}>
				<span
					className="d-inline-flex flex-column align-items-center justify-content-center text-primary text-center map-marker-clustered"
					style={{ textAlign: "center" }}
				>
					<GroupIcon color="primary" />
					<span className="count">{props.agents.length}</span>
				</span>
			</UIStyledTooltip>
		</NavLink>
	);
};

export const MapMarkerClusteredFacilities = (props: { facilities: IPSFacility[]; center: google.maps.LatLng }) => {
	if (!props.facilities || !props.facilities.length) return null;
	const tooltip: string = props.facilities.map((a) => a.name).join(", ");
	const url: string =
		props.facilities.length === 1 ? getFacilityLink(props.facilities[0]) : `/ps/facilities/?q=${tooltip}`;
	// : `/ps/facilities/?lat=${props.center.lat()}&lng=${props.center.lng()}`;
	return (
		<NavLink to={url}>
			<UIStyledTooltip title={tooltip}>
				<span
					className="d-inline-flex flex-column align-items-center justify-content-center text-primary text-center map-marker-clustered"
					style={{ textAlign: "center" }}
				>
					<ApartmentIcon color="primary" />
					<span className="count">{props.facilities.length}</span>
				</span>
			</UIStyledTooltip>
		</NavLink>
	);
};
